'use client';

import cx from 'classnames';
import Image from 'next/image';
import React, { FC } from 'react';

import { IContentImage } from '@/contentful/utils/contentImage';

import IconMark from './assets/icon-mark.svg';

import styles from './part-service-content.module.scss';

interface IPartServiceContentProps {
  data: {
    header: string;
    description: string;
    icon: IContentImage | null;
    image: IContentImage | null | undefined;
    imageMobile: IContentImage | null;
    detailes: string[] | undefined;
  };
}

const PartServiceContent: FC<IPartServiceContentProps> = ({ data }) => (
  <section className={styles.container}>
    <Image
      src={data.image?.src ?? ''}
      alt={data.image?.alt ?? ''}
      width={data.image?.width ?? 0}
      height={data.image?.height ?? 0}
      className={cx(styles.image, 'visibleOnDesktopAndTablet')}
      quality={75}
    />
    <Image
      src={data.imageMobile?.src ?? ''}
      alt={data.imageMobile?.alt ?? ''}
      width={data.imageMobile?.width ?? 0}
      height={data.imageMobile?.height ?? 0}
      className={cx(styles.image, 'visibleOnPhone')}
      quality={75}
    />
    <div className={styles.content}>
      <div className={styles.iconWrap}>
        <div className={styles.iconContainer}>
          <Image
            src={data.icon?.src ?? ''}
            alt={data.icon?.alt ?? ''}
            width={data.icon?.width ?? 0}
            height={data.icon?.height ?? 0}
          />
        </div>
      </div>
      <h2 className={styles.title}>{data.header}</h2>
      <p className={styles.description}>{data.description}</p>
      <ul className={styles.features}>
        {data.detailes
          && data.detailes.map((item) => (
            <li key={item} className={styles.featuresItem}>
              <div className={styles.iconContainer}>
                <IconMark />
              </div>
              <p className={styles.feature}>{item}</p>
            </li>
          ))}
      </ul>
    </div>
  </section>
);

export default PartServiceContent;
